import { isElement } from "./instanceOf.es.js";
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : (
    // $FlowFixMe[prop-missing]
    element.document
  )) || window.document).documentElement;
}
export {
  getDocumentElement as default
};
//# sourceMappingURL=getDocumentElement.es.js.map
